export default __webpack_public_path__ + "static/assistAiBg-29b04303604aaffc9902714adabc3f8c.png";